package com.routexk.quiz.ui.sections.header.components

import androidx.compose.runtime.Composable
import com.routexk.quiz.ui.localization.LocalAppStrings
import com.routexk.quiz.ui.sections.header.IconButtonStyle
import com.routexk.quiz.ui.theme.AppColors
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.cssRem

@Composable
internal fun HamburgerButton(onClick: () -> Unit) {
    val strings = LocalAppStrings.current
    val colorMode = ColorMode.current
    val colors = AppColors.getColors(colorMode)

    Box(
        modifier = IconButtonStyle
            .toModifier()
            .backgroundColor(colors.surfaceVariant)
            .onClick { onClick() }
            .attrsModifier {
                attr("role", "button")
                attr("aria-label", strings.ariaOpenMenu)
                attr("tabindex", "0")
                onKeyDown {
                    if (it.key == "Enter" || it.key == " ") {
                        it.preventDefault()
                        onClick()
                    }
                }
            },
        contentAlignment = Alignment.Center
    ) {
        SpanText("☰", Modifier.fontSize(1.5.cssRem).attrsModifier { attr("aria-hidden", "true") })
    }
}
